var t=function(t){return"".concat((t/(arguments.length>1&&void 0!==arguments[1]?arguments[1]:16)).toFixed(2),"rem")};export{t as p};
//# sourceMappingURL=index-bd9104b0.js.map
